import React, { useState } from 'react';

const MoveInWithUs = (props) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    role: '',
    state: '',
    participantName: '',
    PropertyName: props.home,
    dateOfBirth: '',
    gender: '',
    SDANdisPlan: '',
    ndisNumber: '',
    hasNdisPlan: '',
    expressionOfInterest: '',
    referralSource: ''
  });

  const [submitStatus, setSubmitStatus] = useState('idle'); // 'idle' | 'submitting' | 'success' | 'error'

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('submitting');
    
    try {
      const response = await fetch(BASE_URL+'/api/submit-movein', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          phone: '',
          email: '',
          role: '',
          state: '',
          SDANdisPlan: '',
          participantName: '',
          dateOfBirth: '',
          gender: '',
          ndisNumber: '',
          hasNdisPlan: '',
          expressionOfInterest: '',
          referralSource: ''
        });
        
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }
  };

  const getButtonText = () => {
    switch (submitStatus) {
      case 'submitting':
        return 'SUBMITTING...';
      case 'success':
        return 'SUCCESSFULLY SUBMITTED!';
      case 'error':
        return 'SUBMISSION FAILED';
      default:
        return 'APPLY';
    }
  };

  const getButtonStyles = () => {
    const baseStyles = "w-full py-2 px-4 rounded-full shadow-md transition-colors mt-6 ";
    switch (submitStatus) {
      case 'submitting':
        return baseStyles + "bg-gray-400 text-white cursor-not-allowed";
      case 'success':
        return baseStyles + "bg-green-600 text-white";
      case 'error':
        return baseStyles + "bg-red-500 text-white";
      default:
        return baseStyles + "bg-green-500 text-white hover:bg-green-600";
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 text-xl py-24 bg-white">
      <div className="text-center mb-6">
        <h1 className="bg-primary text-white text-3xl py-2 px-4 rounded-xl font-arial-rounded mb-4">Move In With Us</h1>
        <p className="text-md text-gray-600">
          If you are interested in our support, call us, send us an email or fill out the form below.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-primary mb-1">Full Name (Person completing form)</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">Phone</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-2">I am:</label>
          <div className="space-y-2">
            {['Client', 'Carer', 'Guardian', 'Support Coordinator', 'Other'].map((option) => (
              <div key={option} className="flex items-center">
                <input
                  type="radio"
                  name="role"
                  value={option.toLowerCase()}
                  onChange={handleChange}
                  className="mr-2 text-primary focus:ring-primary"
                />
                <label className="text-gray-700">{option}</label>
              </div>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-primary mb-2">State you are looking at:</label>
          <div className="space-y-2">
            {['South Australia', 'Queensland', 'Victoria'].map((state) => (
              <div key={state} className="flex items-center">
                <input
                  type="radio"
                  name="state"
                  value={state.toLowerCase()}
                  onChange={handleChange}
                  className="mr-2 text-primary focus:ring-primary"
                />
                <label className="text-gray-700">{state}</label>
              </div>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-primary mb-1">Participant's Full Name</label>
          <input
            type="text"
            name="participantName"
            value={formData.participantName}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">Participant's Date of Birth</label>
          <input
            type="date"
            name="dateOfBirth"
            value={formData.dateOfBirth}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">Participant's Gender</label>
          <input
            type="text"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">NDIS Number (If Known)</label>
          <input
            type="text"
            name="ndisNumber"
            value={formData.ndisNumber}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
          />
        </div>

        <div>
          <label className="block text-primary mb-1">Do you currently have a NDIS plan?</label>
          <input
            type="text"
            name="hasNdisPlan"
            value={formData.hasNdisPlan}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">Do you have SDA in your NDIS plan?</label>
          <input
            type="text"
            name="SDANdisPlan"
            value={formData.SDANdisPlan}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">Expression of Interest</label>
          <textarea
            name="expressionOfInterest"
            value={formData.expressionOfInterest}
            onChange={handleChange}
            placeholder="Tell us more about your circumstances, support needs, and services you are interested in"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary h-24"
            required
          />
        </div>

        <div>
          <label className="block text-primary mb-1">How did you hear about us? (Website, social media, Word of Mouth, Other)</label>
          <input
            type="text"
            name="referralSource"
            value={formData.referralSource}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-primary"
            required
          />
        </div>

        <button
          type="submit"
          disabled={submitStatus === 'submitting'}
          className={getButtonStyles()}
        >
          {getButtonText()}
        </button>
      </form>
    </div>
  );
};

export default MoveInWithUs;